import React, { useEffect, useState } from 'react';
import {
  Container,
  Grid,
  Breadcrumbs,
  Link,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link as RouterLink,
  useParams,
  useNavigate,
  useLocation,
} from 'react-router';
import { useUser } from '@/providers';

import ErrorSnackBar from '../../shared/ErrorSnackBar';
import ExecutionLogs from '../../shared/ExecutionLogs';
import { getCollection } from '../../../actions/collections';
import { clearErrorMessage } from '../../../actions/errorMessage';

import toTitleCase from '../../../util/toTitleCase';
import LoadingMask from '../../shared/LoadingMask';

export default function CollectionExecutionLogs() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const location = useLocation();
  const entity_type = location.pathname.split('/')[1];

  const api_error = useSelector((state) => state.errorMessage);
  const collections = useSelector((state) => state[`${entity_type}s`]);
  const user = useUser();

  const [collection, setCollection] = useState(
    collections
      ? collections.find((collection) => collection.id === id)
      : undefined,
  );
  const [collectionLoading, setCollectionLoading] = useState(true);

  useEffect(() => {
    dispatch(clearErrorMessage());
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      if (!collection && user?.selected_project) {
        const collection_data = await getCollection(user.selected_project, entity_type, id);
        if (!collection_data) {
          navigate(`/${entity_type}`);
        }
        setCollection(collection_data);
      } else if (!collection) {
        navigate(`/${entity_type}`);
      }
      setCollectionLoading(false);
    })();
  }, [dispatch, navigate, collection, id, entity_type, user?.selected_project]);

  if (collectionLoading) {
    return <LoadingMask />;
  }

  return (
    <Container>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, md: 12, lg: 12 }}>
              <Breadcrumbs aria-label='breadcrumb'>
                <Link
                  underline='hover'
                  color='inherit'
                  component={RouterLink}
                  to={`/dashboard`}
                >
                  Home
                </Link>
                <Link
                  underline='hover'
                  color='inherit'
                  component={RouterLink}
                  to={`/${entity_type}`}
                >
                  {toTitleCase(`${entity_type}s`)}
                </Link>
                <Link
                  underline='hover'
                  color='inherit'
                  component={RouterLink}
                  to={`/${entity_type}/details/${id}`}
                >
                  {collection.name}
                </Link>
                <Typography color='text.primary'>Execution Logs</Typography>
              </Breadcrumbs>{' '}
            </Grid>
            <br />
            <ExecutionLogs entity={collection} entity_type={entity_type} />
          </Grid>
          <ErrorSnackBar message={api_error} />
        </Container>
  );
}
